import styled from "styled-components"
import {Button, Modal} from "antd"
import {useState} from "react"
import ContactForm from "./ContactForm"

const ReadyToTry = ({items, ...props}) => {

	const [open, setOpen] = useState(false)

	return (
		<>
			<Wrapper {...props}>
				<h2>Готовы попробовать?</h2>
				<p className="description">
					Свяжитесь с нами, и мы предоставим доступ уже сегодня.
				</p>
				<Button onClick={() => setOpen(true)} color="default" variant="solid" size="large">
					Попробовать бесплатно
				</Button>
			</Wrapper>
			<Modal width={660} open={open} onCancel={() => setOpen(false)} footer={null}>
				<ModalContent>
					<Title>Регистрация</Title>
					<div>Мы свяжемся с вами в самое ближайшее время.</div>
					<ContactForm onFinish={() => setOpen(false)}/>
				</ModalContent>
			</Modal>
		</>
	)
}

export default ReadyToTry

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
`
const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    gap: 24px;
`
const Title = styled.div`
    font-size: 34px;
    line-height: 34px;
`